import * as colors from './colors';
import * as typography from './typography';
import * as variables from './variables';
import { easmIconSet } from './easm-icons';
import { entityIconSet } from './entity-icons';

export const IconSets = {
  'easm': easmIconSet,
  'entity': entityIconSet,
};

export { colors, typography, variables };
